export default __webpack_public_path__ + "static/media/icon-help-electricberry.87596f64.svg";